module.exports = __webpack_public_path__ + "img/dengwei-pc.e08d9773.jpg";